<!-- Generated template for the FeaturedonComponent component -->
<ion-row *ngIf="feature.includes('award')" class="ion-no-padding">
  <ion-col size="12">
    <ion-row *ngIf="!excludeNumber1">
      <ion-col size="12" class="ion-text-center component-padding-sm">
        <h3 class="dark">Rated <a routerDirection="root" [routerLink]="'/number1'"><b class="highlightPurple hoverHighlightPurple">Top Coding Bootcamp</b></a> in the US By Graduates</h3>
        <h4 class="stripe-subtitle">
          <span class="fade1">Top Rated on <a href="https://www.coursereport.com/schools/nucamp" target="_blank">Course Report</a></span>
          <br>
          <span class="fade2">Top Rated on <a href="https://www.trustpilot.com/review/nucamp.co" target="_blank">Trust Pilot</a></span>
          <br>
          <span class="fade3"><a routerDirection="root" [routerLink]="'/financing'">Fair Student Agreement</a></span>
          <br>
          <span class="fade4">Most Affordable</span>
          <br>
        </h4>
      </ion-col>
    </ion-row>
    <ion-row class="badgemain" *ngIf="!excludeNumber1">
      <ion-col class="ion-text-center">
        <img src="/assets/imgs/reviews/badge-nucamp-number1.webp" alt="Best coding bootcamp in the USA 2024" />
      </ion-col>
    </ion-row>
    <ion-row class="aligncenter referenceimg">
      <ion-col class="ion-padding-horizontal ion-text-center" size="6" size-md="3" [ngStyle]="{'margin-top': !excludeNumber1 ? '-130px' : '0'}">
        <a href="https://www.coursereport.com/schools/nucamp"
          (click)="this.nucampAnalytics.event('Referrence', 'View', 'Course Report')" target="_blank">
          <img src="/assets/imgs/reviews/badge-course-report-best-online.webp" alt="Voted best online coding bootcamp by Course Report 2024" />
          <p><span class="href"><b>Read Bootcamp Student Reviews</b></span></p>
        </a>
      </ion-col>
      <ion-col class="ion-padding-horizontal ion-text-center" size="6" size-md="3">
        <a href="https://www.forbes.com/advisor/bootcamps/best-devops-bootcamps/?award=best-devops-bootcamps-award-2024-nucamp"
          (click)="this.nucampAnalytics.event('Referrence', 'View', 'Switch-Up')" target="_blank">
          <img src="/assets/imgs/reviews/badge-forbes-best.webp" alt="Voted best online coding bootcamp by Forbes in 2024" height="170px"/>
          <p><span class="href"><b>Read Bootcamp Student Reviews</b></span></p>
        </a>
      </ion-col>
      <ion-col class="ion-padding-horizontal ion-text-center" size="6" size-md="3">
        <a href="https://careerkarma.com/schools/nucamp"
          (click)="this.nucampAnalytics.event('Referrence', 'View', 'Career Karma')" target="_blank">
          <img src="/assets/imgs/reviews/badge-careerkarma-best.webp"
            alt="Voted best coding bootcamp by Career Karma 2023" />
          <p><span class="href"><b>Read Bootcamp Student Reviews</b></span></p>
        </a>
      </ion-col>
      <ion-col class="ion-padding-horizontal ion-text-center" size="6" size-md="3" [ngStyle]="{'margin-top': !excludeNumber1 ? '-130px' : '0'}" [ngStyle]="{'margin-top': !excludeNumber1 ? '-130px' : '0'}">
        <a href="https://www.trustpilot.com/review/nucamp.co"
          (click)="this.nucampAnalytics.event('Referrence', 'View', 'Trust Pilot')" target="_blank">
          <img src="/assets/imgs/reviews/badge-trustpilot-best.webp"
            alt="Rated Excellent by Trust Pilot 2024" />
          <p><span class="href"><b>Read Bootcamp Student Reviews</b></span></p>
        </a>
      </ion-col>
    </ion-row>
  </ion-col>
</ion-row>


<ion-row *ngIf="feature.includes('instructor')" class="ion-no-padding">
  <ion-col size="12" class="ion-text-center">
    <h3 class="dark no-subtitle">Our instructors have worked for</h3>
  </ion-col>
  <ion-col size="12" size-lg="6" class="ion-text-center" class="logocompanies">
    <ion-row>
      <ion-col size="4" class="ion-padding-horizontal">
        <img src="/assets/imgs/reviews/logo-microsoft.png" alt="Microsoft" />
      </ion-col>
      <ion-col size="4" class="ion-padding-horizontal">
        <img src="/assets/imgs/reviews/logo-intel.png" alt="Intel" />
      </ion-col>
      <ion-col size="4" class="ion-padding-horizontal">
        <img src="/assets/imgs/reviews/logo-amazon.png" alt="Amazon" />
      </ion-col>
    </ion-row>
  </ion-col>
  <ion-col size="12" size-lg="6" class="ion-text-center" class="logocompanies">
    <ion-row>
      <ion-col size="4" class="ion-padding-horizontal">
        <img src="/assets/imgs/reviews/logo-starbucks.png" alt="Starbucks" />
      </ion-col>
      <ion-col size="4" class="ion-padding-horizontal">
        <img src="/assets/imgs/reviews/logo-tmobile.png" alt="T-Mobile" />
      </ion-col>
      <ion-col size="4" class="ion-padding-horizontal">
        <img src="/assets/imgs/reviews/logo-zillow.png" alt="Zillow" />
      </ion-col>
    </ion-row>
  </ion-col>
</ion-row>
